import { useState } from 'react';

export default function FilterPanel({ filters, setFilters }) {
  const [showFilters, setShowFilters] = useState(false);
  const [localFilters, setLocalFilters] = useState({
    search: '',
    customer: '',
    work_type: '',
    date_from: '',
    date_to: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLocalFilters((prev) => ({ ...prev, [name]: value }));
  };

  const applyFilters = () => {
    const activeFilters = {};
    Object.entries(localFilters).forEach(([key, value]) => {
      if (value) activeFilters[key] = value;
    });
    setFilters(activeFilters);
  };

  const clearFilters = () => {
    setLocalFilters({
      search: '',
      customer: '',
      work_type: '',
      date_from: '',
      date_to: '',
    });
    setFilters({});
  };

  return (
    <div className="retro-panel mb-6">
      <button
        onClick={() => setShowFilters(!showFilters)}
        data-testid="toggle-filters-button"
        className="retro-btn retro-btn-green mb-4"
      >
        {showFilters ? '[HIDE FILTERS]' : '[SHOW FILTERS]'}
      </button>

      {showFilters && (
        <div className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block mb-2 text-lg font-semibold" style={{ color: '#FF6B00' }}>
                Search:
              </label>
              <input
                type="text"
                name="search"
                data-testid="filter-search-input"
                value={localFilters.search}
                onChange={handleChange}
                className="retro-input w-full"
                placeholder="Search all fields..."
              />
            </div>

            <div>
              <label className="block mb-2 text-lg font-semibold" style={{ color: '#FF6B00' }}>
                Customer:
              </label>
              <input
                type="text"
                name="customer"
                data-testid="filter-customer-input"
                value={localFilters.customer}
                onChange={handleChange}
                className="retro-input w-full"
                placeholder="Customer name..."
              />
            </div>

            <div>
              <label className="block mb-2 text-lg font-semibold" style={{ color: '#FF6B00' }}>
                Work Type:
              </label>
              <select
                name="work_type"
                data-testid="filter-worktype-select"
                value={localFilters.work_type}
                onChange={handleChange}
                className="retro-input w-full"
              >
                <option value="">ALL</option>
                <option value="remote">REMOTE</option>
                <option value="on-site">ON-SITE</option>
              </select>
            </div>

            <div>
              <label className="block mb-2 text-lg font-semibold" style={{ color: '#FF6B00' }}>
                Date From:
              </label>
              <input
                type="date"
                name="date_from"
                data-testid="filter-datefrom-input"
                value={localFilters.date_from}
                onChange={handleChange}
                className="retro-input w-full"
              />
            </div>

            <div>
              <label className="block mb-2 text-lg font-semibold" style={{ color: '#FF6B00' }}>
                Date To:
              </label>
              <input
                type="date"
                name="date_to"
                data-testid="filter-dateto-input"
                value={localFilters.date_to}
                onChange={handleChange}
                className="retro-input w-full"
              />
            </div>
          </div>

          <div className="flex gap-4">
            <button
              onClick={applyFilters}
              data-testid="apply-filters-button"
              className="retro-btn"
            >
              [APPLY FILTERS]
            </button>
            <button
              onClick={clearFilters}
              data-testid="clear-filters-button"
              className="retro-btn retro-btn-magenta"
            >
              [CLEAR FILTERS]
            </button>
          </div>
        </div>
      )}
    </div>
  );
}